import { Grid, Typography } from "@mui/material";
import ContentBox from "src/components/ContentBox/ContentBox";
import { homeSwapTrustAndSafetyFramework } from "src/media/texts/homeSwapTrustAndSafetyFramework";
import { AccordionWrapper } from "src/pages/MainPage/Components/StillUnsure";
import { textStyle } from "src/styles/textstyle";

export default function HomeSwapTrustAndSafetyFramework() {
  return (
    <ContentBox title="" id={"home-swap-trust-and-safety-framework"}>
      <Grid container spacing={5}>
        <Grid item xs={12} md={8}>
          <Typography
            variant="h3"
            sx={{ ...textStyle, fontWeight: "bold", marginBottom: "20px" }}
          >
            HomeSwap Student Trust and Safety Framework
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          {homeSwapTrustAndSafetyFramework.map((item, index) => (
            <AccordionWrapper
              key={index}
              question={index + 1 + ". " + item.header}
              answer={item.answer}
              smallVersion={true}
            />
          ))}
        </Grid>
      </Grid>
    </ContentBox>
  );
}
